interface Opts {
  maxLength?: number;
  decimalValue?: number;
}

const SUFFIXES = ['K', 'M', 'B', 'T'];

export const formatNumber = (number: number, opts?: Opts): string => {
  const { maxLength = 4, decimalValue = 3 } = opts ?? {};
  const length = Math.abs(number).toString().length;

  if (length <= maxLength) {
    return Intl.NumberFormat('en-US').format(number);
  }

  const index = Math.ceil((length - 3) / 3);
  return (
    (number / Math.pow(1000, index)).toFixed(decimalValue).replace(/\.0$/, '') +
    SUFFIXES[index - 1]
  );
};
